import { Flex, Box } from '../../ui/Layout'
import Button from '../../ui/Button'
import { Text } from '../../ui/Typography'
import { useFormConfig } from '../../context/FormConfigContext'
import { Container } from '../Intro'

const ThankYou = () => {
  const { formConfig } = useFormConfig()

  return (
    <Container>
      <Text whiteSpace="pre-wrap" textAlign="center" mb="32px">
        {formConfig.thankYou || 'Thank you for your testimonial!'}
      </Text>
      <Flex justifyContent="center">
        <a style={{ width: '100%' }} href={formConfig.returnUrl} rel="noopener noreferrer">
          <Button width="100%" backgroundColor={formConfig.buttonColor} large label="Return to website" variant="black" />
        </a>
      </Flex>
    </Container>
  )
}

export default ThankYou
